import { useContext } from 'react';
import "./Sidebar.scss";
import { IconsObject } from '../../assets/Menu Icons/Icons';
import { menus } from './SidebarUtils';
import { AppContext } from '../../context/AppContext';
import SideBarMenu from './Menu/SidebarMenu';

const Sidebar = () => {

  const { toggleSidebar, toggle, handleSubmenuToggle, openSubmenu } = useContext(AppContext);

  const adminPostedMenus = menus.filter(menu =>
    ["Dashboard",
      "Announcement",
      "Academic Calendar",
      "Event",
      "News",
      "IQAC",
      "Reports",
      "Alumini",
      "Gallery",
      "Study Materials"
    ].includes(menu.menuName)
  );

  const userSubmittedMenus = menus.filter(menu =>
    ["Help Desk",
      "Feedback",
      "Application for Staff",
      "Ombudsman",
      "Application For Admission",
      "Contact Messages"
    ].includes(menu.menuName)
  );


  return (
    <aside
      className={`sidebarMainContainer ${toggle ? "expanded" : "collapsed"}`}
    >
      <div className="burgerMenuParent" onClick={toggleSidebar}>
        <span className="burger-icon">{IconsObject.burgerMenu(25)}</span>
      </div>

      <div className={`menuList ${!toggle ? "centered" : ""}`}>

        {/* Section 1: User Submitted */}
        <div className="menu-section">
          {toggle && <h3 className="menu-section-title">Admin Posted Information</h3>}
          {adminPostedMenus.map((menu, index) => (
            <div style={{ display: "flex", flexDirection: "column", gap: "5px", margin: "8px 0px" }}>
              <SideBarMenu
                key={index}
                path={menu.path}
                menuName={menu.menuName}
                menuIcon={menu.menuIcon}
                isCollapsed={!toggle}
                subMenus={menu.subMenus || []}
                onToggle={() => handleSubmenuToggle(menu.menuName)}
                isOpen={openSubmenu === menu.menuName}
                toggle={toggle}
              />
            </div>
          ))}
        </div>

        {/* Section 2: User Submitted */}
        <div className="menu-section">
          {toggle && <h3 className="menu-section-title">User Submitted Data</h3>}
          {userSubmittedMenus.map((menu, index) => (
            <div style={{ display: "flex", flexDirection: "column", gap: "5px", margin: "8px 0px" }}>
              <SideBarMenu
                key={index}
                path={menu.path}
                menuName={menu.menuName}
                menuIcon={menu.menuIcon}
                isCollapsed={!toggle}
                subMenus={menu.subMenus || []}
                onToggle={() => handleSubmenuToggle(menu.menuName)}
                isOpen={openSubmenu === menu.menuName}
                toggle={toggle}
              />
            </div>
          ))}

        </div>
      </div>
    </aside >
  );
};

export default Sidebar;
